import { render, staticRenderFns } from "./LabelDropdownItem.vue?vue&type=template&id=bc4c5752&scoped=true&"
import script from "./LabelDropdownItem.vue?vue&type=script&lang=js&"
export * from "./LabelDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./LabelDropdownItem.vue?vue&type=style&index=0&id=bc4c5752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4c5752",
  null
  
)

export default component.exports